<template>
<div class="online-paydetail">
  <div class="nav-bar">
    <i
      @click="goDepositHandle"
      class="el-icon-back icon-btn pointer"></i>
    <span
      @click="goDepositHandle"
      class="pointer">{{title}}</span>
  </div>
  <div class="pay-detail">
    <div class="tips-card">
      <div class="subtitle">{{$t('Precautions')}}</div>
      <p class="tips-p"
        v-for="(item,index) in computedDescs"
        :key="index"
      >{{item}}</p>
    </div>
    <div class="content-card">
      <div class="account-list-top-text">{{$t('Withdrawal_account')}}</div>
      <mtaccount-list
        ref="mtlist"
        @send-currentMtInfo="sendCurrentMtInfo"
      ></mtaccount-list>
      <div class="nav-title">{{$t('Payee')}}</div>
      <el-row
      >
        <el-col
          :lg="lgCol"
          :sm="smCol"
          :xs="24"
        >
          <withdraw-chanel-card
            ref="withdrawchanelcard"
            v-loading="feeloading"
            :current-withdraw-info="currentWithdrawInfo"
            @add-collection="addCollection"
          ></withdraw-chanel-card>
        </el-col>

      </el-row>
      <div class="nav-title">{{$t('Amount_that_can_be_withdrawn')}}</div> 
      <p class="balance">{{canWithBablance}}</p>
       <el-row>
        <el-col
          :lg="lgCol"
          :sm="smCol"
          :xs="24"
        >
          <el-form
            class="elform"
            ref="form"
            :model="form"
            :rules="rules"
            label-position="top"
          >
            <el-form-item
              :label="$t('User.outAmount')"
              prop="curentLimitMoney"
              class="has-prefix-item"
            >
              <el-input
                :placeholder="amountTips"
                v-model="form.curentLimitMoney"
                @blur="curentMoneyBlurHandle"
                @input="inputHandle"
              >
                <span slot="prefix">USD</span>
              </el-input>
              <p>{{$t('Trade.poundage')}}: ${{fee}}</p>
            </el-form-item>
            <el-form-item
              :label="$t('Payment_amount')"
              prop="totalAmount"
              class="has-prefix-item"
            >
              <el-input
                disabled
                :value="getBillAmount()"
              >
                <span slot="prefix">{{currentWithdrawInfo.payTypeId == '4'?currentWithdrawInfo.payDetailMap.currency:'USD'}}</span>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-button
                :disabled="submitDisabled"
                type="primary"
                :loading="submitLoading"
                @click="payHandle"
              >{{$t('About.submitText')}}</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </div>
  </div>
  <bank-info-edit-dialog
    :dialog-show="bankInfoDialogShow"
    @close="closeBankInfoHandel"
    @ajax-success="editBankInfoSuccess"
  ></bank-info-edit-dialog>

  <bar-info-edit-dialog
    :dialog-show="barInfoDialogShow"
    :channel-info="channelInfo"
    :bar-title="barTitle"
    @close="closeBarInfoHandel"
    @ajax-success="barInfoAjaxSuccess"
  ></bar-info-edit-dialog>
</div>
</template>

<script>
import {
  LeverWithdraw,
  LeverWithdrawVer,
  getUSDExRateAndFee,
  getBankInfo,
  getPartnerData,
  CommiApply,
} from '@/api/userCenter.js';
import { mapGetters } from 'vuex'
import { unifyNumber } from '@/utils/common'
import {amountInputValidate, onlyTwoBitFloat,} from "@/utils/validate";
import mtaccountList from "@/components/public/mtaccountList";
import withdrawChanelCard from "@/components/public/withdrawChanel/withdrawOrOutCommissionChanelCard";
import barInfoEditDialog from "@/components/myFiles/collection/barInfoEditDialog";

import bankInfoEditDialog from "@/components/myFiles/collection/bankInfoEditDialog"
import {getCustPayTypes,getDictValueApi} from "@/api/user";
export default {
  name: "index",
  components: {
    mtaccountList,
    withdrawChanelCard,
    barInfoEditDialog,
    bankInfoEditDialog,
  },

  created(){
     this.getDictValue();
  },
  data() {
    // 考虑银行卡审核的情况
    let _this = this;
    var validateMoney = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('payChannel.inputMoney')));
      }else {
        if (+value > this.the_current_amount) {
          callback(new Error(this.$t('User.moneyAmountError')));
          return;
        }
        if(!onlyTwoBitFloat(value)){
          callback(new Error(this.$t('User.onlyInputTwoBitNumber')));
          this.$emit('request-err');
          return;
        }else {
          let minimumLimit = _this.currentWithdrawInfo.payTypeId == 4 ? _this.outMoney.minimumLimit : _this.currentWithdrawInfo.minimumLimit;
          let maximumLimit = _this.currentWithdrawInfo.payTypeId == 4 ? _this.outMoney.maximumLimit : _this.currentWithdrawInfo.maximumLimt;
          if(minimumLimit&&value < minimumLimit){
            callback(new Error(_this.$t('At_least_greater_than_the_minimum_withdrawal_amount',{type: minimumLimit})));
          }else if( maximumLimit&&value > maximumLimit){
            callback(new Error(_this.$t('withdrawal_amount_must_be_less_than_the_maximum_amount',{type: maximumLimit})));
          }else{
            callback();
          }
        }
      }
    };
    return {

      /*tips: [
        '1.请用与实际付款人姓名相同的银行卡进行转账。',
        '2.请不要习惯性转账，否则钱款可能无法追回。',
        '3.客户转账金额多于转账限额,款项打入了服务提供商的银行卡且难以追回，一切损失客户需要自行承担损失，公司不会提供任何补偿。',
      ],*/

      currentAccountInfo: {
        availableBalance: '',
      },
      currentWithdrawInfo:{
        examineStatus: '',
        payDetailMap:{
          bankAccount: "",
          bankName: "",
          bankStatus: 0,
          firstName: "",
          lastName: "",
          swiftCode: "",
        },
        maximumLimit: 0,
        minimumLimit: 0,
      },
      outMoney: {
        realExRateWithdraw:1,
        nominalExRateWithdraw:1
      },
      // 表单
      form: {
        curentLimitMoney: '',
        totalAmount: '',
      },
      rules: {
        curentLimitMoney: [
          { required: true, message: _this.$t('please_input'), trigger: 'blur' },
          { validator: validateMoney, trigger: 'blur' },
        ],
      },
      submitLoading: false,

      channelType: 0,
      bankInfoDialogShow: false,
      barInfoDialogShow: false,
      usdtInfo: {},
      otcInfo: {},
      feeloading:true,
      withdrawalratio: '',
    }
  },
  computed: {
    ...mapGetters(['userInfo','realMobile','withdrawDefaultPageTitle','withdrawDefaultType','custPayTypes']),
    canWithBablance(){
      if(this.currentAccountInfo.currency == 'USD'){
        return this.currentAccountInfo.availableBalance + ' USD';
      }else if(this.currentAccountInfo.currency == 'USC'){
        let handlerMoney = unifyNumber(this.currentAccountInfo.availableBalance / 100);
        return `${this.currentAccountInfo.availableBalance} USC (${handlerMoney} USD)`;
      }
    },
    the_current_amount(){
      if(this.currentAccountInfo.currency == 'USD'){
        return this.currentAccountInfo.availableBalance;
      }else if(this.currentAccountInfo.currency == 'USC'){
        let handlerMoney = unifyNumber(this.currentAccountInfo.availableBalance / 100);
        return handlerMoney;
      }
    },
    lgCol(){
      if(window.innerWidth > 1280){
        return 12;
      }else {
        return 12;
      }
    },
    smCol(){
      if(window.innerWidth > 1280){
        return 12;
      }else {
        return 12;
      }
    },
    barTitle(){
      if(this.channelType == 2){
        return 'USDT';
      }else if(this.channelType == 3){
        return this.$t('withdraw365');
      }
    },
    channelInfo(){
      if(this.channelType == 2){
        return this.usdtInfo;
      }else {
        return this.otcInfo;
      }
    },
    computedDescs(){
      // 789 todo
      let minimumLimit = this.currentWithdrawInfo.payTypeId == 4 ? this.outMoney.minimumLimit : this.currentWithdrawInfo.minimumLimit;
      let maximumLimit = this.currentWithdrawInfo.payTypeId == 4 ? (this.outMoney.maximumLimit || '∞') : (this.currentWithdrawInfo.maximumLimt || '∞');
      let firstLine = `1.${this.$t('User.limit')}$${minimumLimit}~$${maximumLimit}。`;
      switch (+this.$route.params.payTypeId){
        case 4:
        case 7:
            return  [
              firstLine,
              this.$t('withdrawBankCardTipsSecondLine'),
              '3.' + this.$t('User.withdrawtipsName') + this.withdrawalratio + this.$t('User.withdrawtipsAction'),
              '4.' + this.$t('withdrawBankCardTipsThirdlyLine'),
              
            ];
        case 5:
        case 8:
          return  [
            firstLine,
            this.$t('withdrawUsdtTipsSecondLine'),
            '3.' + this.$t('User.withdrawtipsName') + this.withdrawalratio + this.$t('User.withdrawtipsAction'),
            '4.' + this.$t('withdrawBankCardTipsThirdlyLine'),
          ];
        case 6:
        case 9:
          return  [
            firstLine,
            '2.' + this.$t('withdrawOtcTipsSecondLine'),
            '3.' + this.$t('User.withdrawtipsName') + this.withdrawalratio + this.$t('User.withdrawtipsAction'),
            '4.' + this.$t('withdrawOtcTipThirdlyLine'),
            '5.' + this.$t('withdrawBankCardTipsThirdlyLine'),
            
          ];
      }
    },
    fee(){
      if(this.currentWithdrawInfo.payTypeId == 4){
        return 0;
      }else {
        return 1;
      }
    },
    title(){
      let strTitle = '';
      if(this.currentWithdrawInfo.payTypeId ==4){
        strTitle = this.$t('Bank_card');
      }else if(this.currentWithdrawInfo.payTypeId == 5){
        strTitle = 'USDT';
      }else if(this.currentWithdrawInfo.payTypeId == 6){
        strTitle = `withdraw365(${this.$t('Original')}OTC365)`;
      }
      return strTitle;
    },
    amountTips(){
      return `≥${this.currentWithdrawInfo.payTypeId == 4 ? (this.outMoney.minimumLimit || '') : this.currentWithdrawInfo.minimumLimit}`
    },
    submitDisabled(){
      let flag = false;

      switch (this.currentWithdrawInfo.payTypeId) {
        case 4:
        case 7:
          let key;
          if (!this.currentWithdrawInfo.payDetailMap.bankAccount || this.currentWithdrawInfo.examineStatus == 1 || this.currentWithdrawInfo.examineStatus == 2 || this.feeloading) {
            flag = true;
          }
          break;
        case 5:
        case 8:
          if (!this.currentWithdrawInfo.payDetailMap.address) {
            flag = true;
          }
          break;
        case 6:
        case 9:
          if (!this.currentWithdrawInfo.payDetailMap.address) {
            flag = true;
          }
          break;
      }
      return flag;
    }
  },
  watch: {
    custPayTypes: {
      handler(newVal) {
        if (newVal) {
          this.queryPayTypes();
        }
      },
      immediate: true
    }
  },
  mounted(){
    let reouterview = document.getElementById('routerview');
    reouterview.classList.add('no-padding-import');
    this.getWithdrawInfo();
    
  },
  beforeDestroy(){
    let reouterview = document.getElementById('routerview');
    reouterview && reouterview.classList.remove('no-padding-import');
  },
  methods: {
    convertToPercentageIntl(numStr, decimals = 0) {
      const num = parseFloat(numStr);
      if (isNaN(num)) {
        throw new Error('无效的输入');
      }
      return new Intl.NumberFormat('en-US', {
        style: 'percent',
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals
      }).format(num);
    },
    getDictValue(){
      getDictValueApi({
        type: 'WITHDRAW_RATIO',
      }).then((res) => {
        if(res.data&&res.data.content[0]){
          this.withdrawalratio = this.convertToPercentageIntl(res.data.content[0].value);
        }
      })
    },
    addCollection(channelType){
      this.queryPayTypes();
      this.channelType = channelType;
      if(this.channelType == 1){
        this.bankInfoDialogShow = true;
      }else {
        this.barInfoDialogShow = true;
      }
    },
    closeBankInfoHandel(){
      this.bankInfoDialogShow = false;
    },
    // 绑定收款信息的
    queryPayTypes() {
      const data = this.custPayTypes;
      if (data) {
        for (let i = 0; i < data.length; i++) {
          if (data[i].payTypeId == 5) {
            this.usdtInfo = data[i];
          }
          if (data[i].payTypeId == 6) {
            this.otcInfo = data[i];
          }
        }
      }
    },

    editBankInfoSuccess(){
      this.bankInfoDialogShow = false;
      this.updateCollectionInfo();
    },
    closeBarInfoHandel(){
      this.barInfoDialogShow = false;
    },

    barInfoAjaxSuccess(){
      this.barInfoDialogShow = false;
      this.updateCollectionInfo();
    },
    updateCollectionInfo(){
      this.getWithdrawInfo();
    },

    inputHandle(val){
      this.form.curentLimitMoney = amountInputValidate(val);
    },
    curentMoneyBlurHandle(){
      // 看需要要查询费率 todo
      // this.queryExchangeRate();
    },
    sendCurrentMtInfo(currentMtInfo){
      this.currentAccountInfo = currentMtInfo;
    },
    getUSDExRateAndFee() {
      let parmas = {
        oprType: 2,
        depCurrency:this.currentWithdrawInfo.payDetailMap.currency
      };
      getUSDExRateAndFee(parmas).then((res) => {
        this.outMoney = res.data[0] ? res.data[0] : {};
        this.feeloading = false;
      });
    },
    //获取收款信息
    getWithdrawInfo() {
      getBankInfo({
        custId: this.userInfo.id,
        type: 1,
      }).then((res) => {
        for (let i = 0; i < res.data.length; i++) {
          if(res.data[i].payTypeId == this.$route.params.payTypeId){
            this.currentWithdrawInfo = res.data[i];
            break;
          }
        }
        //如果是银行卡  其他的话汇率都是1
        if( this.currentWithdrawInfo.payTypeId == 4){
            this.getUSDExRateAndFee();  
        }else{
            this.feeloading = false;
        }
      })
    },


    payHandle(item){
      // 未有出金渠道绑定时,不让提交

      if(!this.currentAccountInfo.availableBalance || +this.form.curentLimitMoney > +this.currentAccountInfo.availableBalance){
        this.$vs.notify({
          text: this.$t('Insufficient_balance'),
          position: 'top-center',
          color: 'warning'
        })
        return;
      }
      this.$refs.form.validate((valid) => {
        if(valid){
          //  本地汇款：确认支付跳转第三方页面，本页面变成【提交成功】
          this.withdrawRequest();

        }else {
          console.log('no-pass');
        }
      })
    },
    withdrawRequest(){
      let currentMtInfo = this.$refs.mtlist.currentMt4Info;
      let parmas = {
        custId: this.userInfo.id,
        serverId: currentMtInfo.serverId,
        login: currentMtInfo.login,
        amount: this.form.curentLimitMoney,
        billAmount: this.getBillAmount(),
        group: currentMtInfo.group,
        type: 2,
        currency:  this.currentWithdrawInfo.payTypeId == 4 ? this.currentWithdrawInfo.payDetailMap.currency: 'USD' ,
        phoneVerCode: '',
        realExRate: this.currentWithdrawInfo.payTypeId == 4 ? this.outMoney.realExRateWithdraw: 1,
        nominalExRate: this.currentWithdrawInfo.payTypeId == 4 ? this.outMoney.nominalExRateWithdraw: 1,   
        payTypeId: this.currentWithdrawInfo.payTypeId,
      };
      this.submitLoading = true;
      LeverWithdraw(parmas).then((res) => {
        this.submitLoading = false;
        this.$router.push({name: 'successWithdrawSubmit'}).catch(() => {
          window.location.href = this.$router.resolve({name: 'successWithdrawSubmit'}).href;
        });
      }).catch((error) => {
        this.submitLoading = false;
      })
    },
    getBillAmount(){
      if (this.currentWithdrawInfo.payTypeId == 4){
        return (this.form.curentLimitMoney * this.outMoney.nominalExRateWithdraw).toFixed(2);
      }else {
        if(!this.form.curentLimitMoney){
          return 0
        }
        return this.form.curentLimitMoney - 1;
      }
    },
    goDepositHandle(){
      this.$router.push({name: 'withdraw'});
    },

  },
}
</script>

<style lang="scss" scoped>

.online-paydetail {
  .nav-bar {

    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding-left: 20px;
    .icon-btn {
      font-size: 16px;
    }
  }
  .pay-detail {
    padding: 24px;
    .tips-card,
    .content-card {
      background-color: #ffffff;
      border-radius: 10px;
      margin-bottom: 24px;
      padding: 24px;
      .has-prefix-item {
        /deep/ .el-input__inner {
          padding-left: 60px;
        }
        /deep/ .el-input__prefix {
          left: 16px
        }
      }
    }
    .subtitle {
      font-size: 16px;
      font-weight: 600;
      color: #5E5873;
      margin-bottom: 20px;
    }
    .tips-card {
      .tips-p {
        color: #5E5873;
      }
    }

    .nav-title {
      font-size: 16px;
      font-weight: 600;
      color: #5E5873;
      margin-top: 20px;
      margin-bottom: 10px;
    }

    .balance {
      font-size: 16px;
      font-weight: 600;
      //color: #D85E5F;
      margin-bottom: 20px;
    }
  }
}
</style>
